import { FC, PropsWithChildren, createContext } from 'react'
import { FreeQrCodeGeneratorPageProps } from '../../../../../components/pages/FreeQrCodeGeneratorPage/FreeQrCodeGeneratorPage'

export type LOCGPrismicContextType = Pick<
  FreeQrCodeGeneratorPageProps,
  | 'homepageData'
  | 'bannerData'
  | 'locgV2Data'
  | 'homepageBelowFoldExperimentData'
  | 'nonGeneratorAboveFoldData'
>

export const LOCGPrismicContext = createContext<LOCGPrismicContextType | undefined>(undefined)

export const LOCGPrismicProvider: FC<PropsWithChildren<LOCGPrismicContextType>> = props => {
  return <LOCGPrismicContext.Provider value={props}>{props.children}</LOCGPrismicContext.Provider>
}
